<template>
    <div class="orders osago">
        <div class="container">
            <div class="row flex-lg-row-reverse">
                <div class="col-lg-4">
                </div>
                <div class="col-lg-8">
                    <a href="javascript:void(0);" class="go-back" @click="$router.go(-1)">
                        Повернутися до оформлення
                    </a>
                    <form class="step-block">
                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-12">
                                        <h3>
                                            <span>Дані страхувальника (Покупець)</span>
                                        </h3>
                                    </div>
                                    <div class="col-lg-12 row passport-row">
                                        <div class="col-lg-6">
                                            <div class="info-block">
                                                <b>Повне ім'я</b>
                                                <p>{{ payer.name_ua + ' ' + payer.patronymic_ua + ' ' + payer.surname_ua}}</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="info-block">
                                                <b>Дата народження</b>
                                                <p>{{ payer.dateBirth}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 row passport-row">
                                        <div class="col-lg-6">
                                            <div class="info-block">
                                                <b>{{ getPlaceholderSerial() }}</b>
                                                <p>{{ payer.documentation.serial}}</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="info-block">
                                                <b>{{ getPlaceholderNumber()}}</b>
                                                <p>{{ payer.documentation.number}}</p>
                                            </div>
                                        </div>

                                        <div v-if="payer.documentation.dateOfIssue" class="col-lg-6">
                                            <div class="info-block">
                                                <b>Дата видачі документа</b>
                                                <p>{{ payer.documentation.dateOfIssue}}</p>
                                            </div>
                                        </div>

                                        <div v-if="payer.documentation.endDateOfIssue" class="col-lg-6">
                                            <div class="info-block">
                                                <b>Закінчення дії документа</b>
                                                <p>{{ payer.documentation.endDateOfIssue}}</p>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-lg-12 row passport-row">
                                        <div class="col-lg-6">
                                            <div class="info-block">
                                                <b>ІПН</b>
                                                <p>{{ payer.identificationCode}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 row passport-row">
                                        <div class="col-lg-6">
                                            <div class="info-block">
                                                <b>Email</b>
                                                <p>{{ payer.mail}}</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="info-block">
                                                <b>Номер телефону</b>
                                                <p>{{ payer.phone}}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 row passport-row">
                                        <div class="col-lg-6">
                                            <div class="info-block">
                                                <b>Адреса</b>
                                                <p>{{ (payer.city ? (payer.city.name_ua || payer.city.name) : '')  + ', '+ payer.street + ', '+ payer.house }}{{payer.apartment ? ', ' + payer.apartment : ''}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <hr/>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <h3 class="mt">
                                            <span>Застрахований об'єкт</span>
                                        </h3>
                                    </div>
                                    <div class="col-lg-12 row passport-row">
                                        <div class="col-lg-6">
                                            <div class="info-block">
                                                <b>Місто</b>
                                                <p>{{ typeof homeObjectInfo.city === 'object' ? homeObjectInfo.city.name_full_name_ua : homeObjectInfo.city }}</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="info-block">
                                                <b>Вулиця</b>
                                                <p>{{ this.homeObjectInfo.street }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 row passport-row">
                                        <div class="col-lg-6">
                                            <div class="info-block">
                                                <b>Номер будинку</b>
                                                <p>{{ this.homeObjectInfo.house }}</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="info-block">
                                                <b>Квартира</b>
                                                <p>{{ this.homeObjectInfo.apartment }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-lg-12 row passport-row">
                                        <div class="col-lg-3">
                                            <div class="info-block">
                                                <b>Загальна вартість:</b>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 param-price">
                                            <div class="result__price">
                                                <div v-if="fullInfo && (fullInfo.dynamicDiscountedSum > 0 || fullInfo.discountPrice > 0)" class="old"
                                                     data-placement="bottom" data-toggle="tooltip"
                                                     title="Знижка надається безпосередньо за наш рахунок від ціни, що надається страховою компанією. Ми забезпечуємо найнижчу ціну на ринку. Вартість поліса вказана з урахуванням знижки.">
                                                    <span>{{ fullInfo.price }} <span>грн</span></span>
                                                    <b v-if="fullInfo.dynamicDiscountedSum > 0">-{{ fullInfo.dynamicDiscountedSum }} грн</b>
                                                    <b v-else >-{{ fullInfo.discountPercent }}%</b>
                                                </div>

                                                <div data-toggle="tooltip" data-html="true"  data-id="details-discount-tooltip" :title="showPriceDetails" v-if="fullInfo.dynamicDiscountPrice > 0 || fullInfo.discountPrice > 0" :class="['price','value','red']">
                                                    {{ showFinishPrice }} <span>грн</span>
                                                </div>
                                                <div v-else :class="['value']" data-original-title="">
                                                    {{ showFinishPrice }} <span>грн</span>
                                                </div>
                                            </div>
                                        </div>
                                        <use-bonus
                                            class="col-lg-6"
                                            @show-earnings="showEarnings = $event"
                                            @use-bonuses="useBonuses = $event"
                                        ></use-bonus>
                                    </div>
                                    <earnings class="col-12 passport-row"  v-show="(earnings || fullInfo.dynamicEarnings) && showEarnings "
                                              :earnings="earnings"
                                              :discount-details="fullInfo.discountDetails"
                                              :use-bonuses="useBonuses"
                                              :data-is-load-earning="dataIsLoadEarning"
                                              v-model="bonusSystemValue"
                                    ></earnings>

                                    <div v-if="confirmContractStatus" class="col-lg-12 text-center position-relative">
                                        <button
                                            type="button"
                                            v-on:click="showDraft()"
                                            class="btn btn-dark">
                                            Переглянути чернетку
                                        </button>
                                    </div>
                                    <div v-if="!confirmContractStatus" class="col-lg-6 text-center position-relative">
                                        <router-link to="/home-steps">
                                            <button
                                                type="button"
                                                class="btn btn-warning">
                                                Редагувати дані
                                            </button>
                                        </router-link>
                                    </div>

                                    <div class="col-12">
                                        <hr/>
                                    </div>
<!--                                    <dynamic-discount-block-->
<!--                                        :data-confirm-contract-status="confirmContractStatus"-->
<!--                                        :data-set-discounted-price-status="setDiscountedPriceStatus"-->
<!--                                        :data-full-info="fullInfo"-->
<!--                                        :data-otp-flags="otpFlags"-->
<!--                                        @update:tooltip="updateTooltip"-->
<!--                                        @update:priceChanged="discountPriceChanged"-->
<!--                                    ></dynamic-discount-block>-->
                                    <div class="col-lg-12" v-if="! confirmContractStatus">
                                        <div class="form-check">
                                            <input v-model="agreement" type="checkbox" id="personal" class="form-check-input">
                                            <label for="personal" :class="['form-check-label', { error : !agreement && submitCheck}]">Згоден з обробкою персональних даних. Дані будуть передані в страхову компанію для формування поліса</label>
                                        </div>
                                    </div>
                                    <div v-if="! confirmContractStatus" class="col-12 text-center position-relative">
                                        <button
                                            :disabled="otpFlags.confirmOtpStatus || !setDiscountedPriceStatus"
                                            v-loading="loadingOrder"
                                            type="button"
                                            v-on:click="makeContract('make')"
                                            class="btn btn-blue">Заявити</button>
                                    </div>
                                    <otp-block
                                        ref="otpBlock"
                                        :data-otp-flags="otpFlags"
                                        :data-agreement="true"
                                        :data-confirm-contract-status="confirmContractStatus"
                                        @formSendOtp="formSendOtp"
                                        @otpCheck="otpCheck"
                                        @otpChanged="otpChanged"
                                    ></otp-block>
                                    <div v-if="confirmContractStatus && setDiscountedPriceStatus && otpFlags.otpStatus && otpFlags.confirmOtpStatus" class="col-lg-12 text-center position-relative">
                                        <button
                                            v-if="orderPaid"
                                            type="button"
                                            class="btn btn-success"
                                        >
                                            Сплачено
                                        </button>
                                        <button
                                            v-else
                                            type="button"
                                            :disabled="dataIsLoadEarning"
                                            v-loading="dataIsLoadEarning"
                                            @click="showAllOrderPaymentWays()"
                                            class="btn btn-warning">
                                            Сплатити поліс
                                        </button>
                                    </div>
                                    <div v-if="showFileInputReceipt" class="col-12 text-center">
                                        <file-input :http-request="uploadReceipt" @remove-file="receiptLoaded = false">Прикріпити файл квитанції</file-input>
                                    </div>
                                    <div  class="col-12 text-center position-relative">
                                        <button
                                            :disabled="!canConfirmContract"
                                            type="button"
                                            @click="confirmContract()"
                                            :class="['btn', (canConfirmContract ? 'btn-blue' : 'btn-dark-grey')]"
                                        >Оформити
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <modalDocument></modalDocument>
        <animationModal></animationModal>
        <modal-response-status :data-response="dataResponse" :data-product-type="dataProductType"></modal-response-status>
        <modal-response-confirm-status :data-response="dataResponse" :data-product-type="dataProductType"></modal-response-confirm-status>
        <modalSuccess @showload="downloadContract()"></modalSuccess>
        <modal-home-success ref="modalHomeSuccess"></modal-home-success>
        <choice-otp-sending-direction ref="ChoiceOtpSendingDirection" @sendOtpApi="sendOtpApi"></choice-otp-sending-direction>
        <modal-declared-success ref="modalDeclaredSuccess"></modal-declared-success>
        <modal-get-invoice-order ref="modalGetInvoiceOrder"></modal-get-invoice-order>
        <modal-get-instant-loan ref="modalGetInstantLoan"></modal-get-instant-loan>
        <modal-get-mono-pay-parts ref="showModalGetMonoPayParts"></modal-get-mono-pay-parts>
        <modal-get-all-payment-ways
            ref="modalGetAllPaymentWays"
            @showModalGetInvoiceOrder="showModalGetInvoiceOrder"
            @showModalGetInstantLoan="showModalGetInstantLoan"
            @showModalGetMonoPayParts="showModalGetMonoPayParts"
            @showModalGetInvoiceLegal="showModalGetInvoiceLegal"
            :is-legal-type="isLegalType"
            :company-id="companyId"
            :program-name="programName"
        >
        </modal-get-all-payment-ways>
        <modal-disable-create-orders ref="showModalDisableCreateOrders"></modal-disable-create-orders>

        <fin-monitoring :visible.sync="showFinMonitoringModal" @confirm="confirmFinMonitoring"></fin-monitoring>
    </div>
</template>
<script>
import axios from 'axios';
import { contractHome } from '@/api/contractHome';
import { checkPayment } from '@/api/invoice';
import { downloadInvoiceLegal, downloadOrder, getPaymentInvoice, showOrder } from '@/api/order';
import { orderHome } from '@/api/orderHome';
import Earnings from '@/components/app/bonusSystem/Earnings.vue';
import UseBonus from '@/components/app/bonusSystem/UseBonus.vue';
import dynamicDiscountBlock from '@/components/app/dynamic-discount/dynamicDiscountBlock.vue';
import FileInput from '@/components/app/forms/FileInput.vue';
import modalDocument from '@/components/app/modals/modal-flight-document.vue';
import modalSuccess from '@/components/app/modals/modal-green-card-success.vue';
import animationModal from '@/components/app/modals/modal-payAnimation.vue';
import modalResponseConfirmStatus from '@/components/app/modals/modal-response-confirm-status.vue';
import modalResponseStatus from '@/components/app/modals/modal-response-status.vue';
import {
  ChoiceOtpSendingDirection,
  DeclaredSuccess as ModalDeclaredSuccess,
  GetAllPaymentWays as ModalGetAllPaymentWays,
  GetInstantLoan as ModalGetInstantLoan,
  GetPaymentLink as ModalGetInvoiceOrder,
  GetMonoPayParts as ModalGetMonoPayParts,
  DisableCreateOrders as ModalDisableCreateOrders
} from '@/components/app/modals/order';
import FinMonitoring from '@/components/app/modals/order/FinMonitoring.vue';
import otpBlock from '@/components/app/otp/otpBlock.vue';
import { otpFunc } from '@/mixin';
import order from '@/mixin/order';
import ModalHomeSuccess from '@/views/home/components/ModalHomeSuccess.vue';

export default {
  components: {
    dynamicDiscountBlock, FileInput,
    FinMonitoring,
    modalSuccess,
    modalDocument,
    animationModal,
    modalResponseConfirmStatus,
    modalResponseStatus,
    ModalDeclaredSuccess,
    ModalGetAllPaymentWays,
    ModalGetInvoiceOrder,
    ModalGetInstantLoan,
    ModalGetMonoPayParts,
    ChoiceOtpSendingDirection,
    UseBonus,
    otpBlock,
    Earnings,
    ModalHomeSuccess,
    ModalDisableCreateOrders,
  },
  mixins: [ otpFunc, order ],

  data: function () {
    return {
      searchInfo: null,
      order: null,
      loadingOrder: false,
      homeObjectInfo: {
        city: {
          name_full_name_ua: '',
        },
        street: '',
        house: '',
        apartment: '',
      },
      earnings: 0,
      useBonuses: false,
      showEarnings: false,
      bonusSystemValue: 0,
      dataIsLoadEarning: true,
      confirmContractStatus: false,
      setDiscountedPriceStatus: true,
      dataResponse: null,
      agreement: false,
      contractId: null,
      orderId: null,
      companyId: null,
      programName: null,
      submitCheck: false,
      otpFlags:{
        otpPass: '', // ОТР - код
        additionalOtps: {}, // Додаткові ОТП коди
        otpStatus: true, // true - Включить отправку ОТР - кода
        confirmOtpStatus: false, // true - OTP код проверен успешно
        sentOtpPass: false, // true - OTP код был отправлен mail/viber/sms
        sendingOtpError: false, // true - при отправке ОТР кода произошла ошибка
        submitOtpCheck: false, // true - была нажата кнопка отправки ОТР кода на проверку
        otpCodeValidate: true, // статус проверки ОТР кода true - прошел проверку, false - код неверный
        pandingOtpSending: false, // флаг для отображения прелоадера при отправке ОТР кода
        pandingOtpCheck: false, // флаг для отображения прелоадера при отправке ОТР кода на проверку
      },

      dataProductType: 'home',
      isLegalType: false,
      showFinMonitoringModal:false,
      payer: {
        'identificationCode': '',
        'withoutDocuments': false,
        'name_ua': '',
        'surname_ua': '',
        'patronymic_ua': '',
        'dateBirth': '',
        'phone': '',
        'mail': '',
        'city': '',
        'street': '',
        'house': '',
        'apartment': '',
        'documentType': 2,
        'passportSerial': '',
        'passportNumber': '',
        'passportDate': '',
        'withoutIdentificationCode': false,
        'documentation': {
          'type': 2,
          'serial': '',
          'number': '',
          'issuedBy': '',
          'dateOfIssue': '',
          'endDateOfIssue': '',
          'dateOfIssueError': false,
          'documentType': ''
        }
      },
    };
  },

  watch: {
    'otpFlags': {
      handler: function(newVal, oldVal) {
        let offerInfo = Object.assign({}, this.offerInfo);
        offerInfo.otpFlags = newVal;
        this.updateStore(offerInfo);
      },
      deep: true,
    },
  },

  async created() {
    await this.$store.dispatch('initHomeInfoOrder');
    await this.$store.dispatch('initHomeFullInfoOrder');

    //this.fetchOfferInfo(this.$store.getters.HOME_INFO_OFFER);
    this.fetchSearchInfo(this.$store.getters.HOME_SEARCH_PARAMS);
    this.fetchOrder(this.$store.getters.HOME_FULL_ORDER);
    this.fetchUserInfo(this.$store.getters.HOME_INFO_USER);
    this.fetchHomeObjectInfo(this.$store.getters.HOME_HOUSE_INFO);
    this.fetchOtpFlags(this.fullInfo.otpFlags);
    this.companyId = this.offerInfo?.companyId;
    this.programName = this.offerInfo?.programName;

    if (this.$store.getters.HOME_FULL_ORDER) {
      this.orderId = this.$store.getters.HOME_FULL_ORDER.orderId;
    }

    this.recalculateEarnings();

    this.confirmContractStatus = this.fullInfo?.confirmContractStatus || false;
    if(this.confirmContractStatus){
      this.setDiscountedPriceStatus = true;
      this.agreement = true;
    }

    showOrder(this.orderId).then(response => {
      this.order = response.data.data;
      this.checkOtpEntered();
      if (this.$route.query.invoice) {
        this.checkPaid(this.$route.query.invoice);
      } else if (this.order.payments) {
        const payments = this.order.payments.find(item => item.invoice.type_id === 2);

        if (payments) {
          this.checkPaid(payments.invoice.id);
        }
      }
    });
  },

  beforeDestroy() {
    if (this.offerInfo.confirmContractStatus) {
      this.$router.replace('/history');
    }
  },

  computed: {
    offerInfo() {
      return this.$store.getters.HOME_INFO_OFFER;
    },

    fullInfo() {
      return this.$store.getters.HOME_FULL_ORDER;
    },

    getParentUserId() {
      return this.$store.getters.USER_INFO.parentId ?? this.$store.getters.USER.id;
    },

    showFinishPrice(){
      const price = this.fullInfo.dynamicDiscountPrice || this.fullInfo.discountPrice || this.fullInfo.fullPrice || this.fullInfo.price;
      return Number(price).toFixed(2);
    },

    showPriceDetails(){
      let isDynamic = this.fullInfo.dynamicDiscountPrice > 0;
      let discountPrice = isDynamic ? this.fullInfo.dynamicDiscountPrice : this.fullInfo.discountPrice;
      if (isDynamic && typeof this.showDynamicDiscountPrice === 'function') {
        discountPrice = this.showDynamicDiscountPrice();
      }
      
      let discountedSum = isDynamic ? this.fullInfo.dynamicDiscountedSum : null;
      if (!isDynamic && this.fullInfo.discountPrice > 0 && this.fullInfo.price > 0) {
        discountedSum = (this.fullInfo.price - this.fullInfo.discountPrice).toFixed(2);
      }
      
      let earnings = this.fullInfo.earnings;
      let dynamicEarnings = isDynamic ? this.fullInfo.dynamicEarnings : null;
      if (isDynamic && typeof this.showDynamicEarnings === 'function') {
        dynamicEarnings = this.showDynamicEarnings();
      }

      if (discountPrice && !isNaN(discountPrice)) discountPrice = Number(discountPrice).toFixed(2);
      if (discountedSum && !isNaN(discountedSum)) discountedSum = Number(discountedSum).toFixed(2);

      let text =
                '<div class=\'details-price-tooltip\'> ' +
                '<div class=\'details-price\'>' +
                '      <div class="tooltip-row">' +
                '        <span class="tooltip-label">Знижка:</span>' +
                '        <span class="tooltip-value">'+ (discountedSum || ' - ') + ' грн</span>' +
                '      </div>' +
                '      <div class="tooltip-row">' +
                '        <span class="tooltip-label">Ціна зі знижкою:</span>' +
                '        <span class="tooltip-value">' + (discountPrice || ' - ')+ ' грн</span>' +
                '      </div>' +
                '      <div class="tooltip-row">' +
                '        <span class="tooltip-label">Загальний заробіток:</span>' +
                '        <span class="tooltip-value">' + (earnings || ' - ') + ' грн</span>' +
                '      </div>' ;
      if(isDynamic){
        text +=  '<div class="tooltip-row">' +
                    '        <span class="tooltip-label">Заробіток зі знижкою:</span>' +
                    '        <span class="tooltip-value">' + (dynamicEarnings || ' - ') + ' грн</span>' +
                    '      </div>' ;
      }
      text += '</div> ';
      '</div>';
      return text;
    },

    orderPaid() {
      if (this.order && this.order.payments && this.order.payments.length) {
        const sumPay = this.order.payments.reduce((sumPay, item) => {
          if (item.invoice.status_id === 2) {
            return sumPay + parseFloat(item.invoice.amount);
          }
          return sumPay;
        }, 0,);
        return sumPay >= this.order.allPrice;
      }

      return false;
    },
  },

  methods: {
    fetchOrder(data){
      if(data){
        this.order = data;
        this.orderId = this.order.orderId;
      }
    },

    fetchOtpFlags(data){
      if(data){
        this.otpFlags = data;
      }
    },

    fetchSearchInfo(data){
      if(data){
        this.searchInfo = data;
      }
    },

    fetchUserInfo(data){
      if(data){
        this.payer = data;
      }
    },

    fetchHomeObjectInfo(data) {
      if (data) {
        this.homeObjectInfo = data;
      }
    },

    getPlaceholderSerial() {
      if (this.payer?.documentation?.type == 3) {
        return 'Запис ID-паспорта';
      }

      return 'Серія паспорту';
    },

    getPlaceholderNumber() {
      if (this.payer.documentation.type == 3) {
        return 'Номер ID-паспорта';
      }

      return 'Номер паспорту';
    },

    checkPaid(invoiceId) {
      checkPayment(invoiceId).then(response => {
        if (response?.data?.data?.invoice?.status_id === 2) {
          showOrder(this.orderId).then(response => this.order = response.data.data);
        }
      });
    },

    updateStore(offerInfo){
      this.$store.commit('SET_HOME_INFO_OFFER', offerInfo);
      this.$store.commit('SET_HOME_FULL_ORDER', this.orderId);
    },

    discountPriceChanged() {
      this.setDiscountedPriceStatus = this.confirmContractStatus || false;
    },

    updateTooltip(data) {
      this.dataIsLoadEarning = true;

      let offerInfo = Object.assign({}, this.offerInfo);

      const discountDetails = {
        dynamicDiscountPrice: 0,
        dynamicDiscountPercent: 0,
        dynamicDiscountedSum: 0,
        dynamicEarnings: 0
      };
      if (parseFloat(data.price) > parseFloat(data.discountPrice)) {
        discountDetails.dynamicDiscountPrice = +parseFloat(data.discountPrice).toFixed(2);
        discountDetails.dynamicDiscountPercent = +parseFloat(data.discountPercent).toFixed(2);
        discountDetails.dynamicDiscountedSum = +parseFloat(data.discountedSum).toFixed(2);
        discountDetails.dynamicEarnings = +parseFloat(data.earnings).toFixed(2);
        discountDetails.earnings = +parseFloat(offerInfo.earnings).toFixed(2);
      }
      offerInfo.discountDetails = discountDetails;
      offerInfo = { ...offerInfo, ...discountDetails };
      this.updateStore(offerInfo);

      const searchInfo = {
        startDate: this.searchInfo.startDate,
        homeType: this.searchInfo.homeType.param,
        insuranceAmount: this.searchInfo.insuranceAmount.param,
        insurancePeriod: this.searchInfo.insurancePeriod.param,
        earnings: this.searchInfo.earning.value,
      };

      this.dataIsLoadEarning = false;
      let params = {
        type: 'next',
        statusId: null,
      };

      this.loadingOrder = true;
      orderHome(this.fullInfo, searchInfo, this.payer, this.homeObjectInfo, this.orderId, params).then((response) => {
        this.setDiscountedPriceStatus = true;
        this.loadingOrder = false;
      });
    },

    showModalGetInvoiceOrder(orderData, provider) {
      const price = this.fullInfo.dynamicDiscountPrice || this.order.fullPrice || this.order.price;
      this.$refs.modalGetInvoiceOrder.open(this.orderId, price, provider);
    },

    showModalGetInstantLoan() {
      this.$refs.modalGetInstantLoan.open(this.order.id, this.fullInfo.dynamicDiscountPrice || this.order.fullPrice || this.order.price);
    },

    showModalGetMonoPayParts() {
      const price = this.fullInfo.dynamicDiscountPrice || this.order.fullPrice || this.order.price;
      this.$refs.showModalGetMonoPayParts.open(this.orderId, price, []);
    },

    showModalGetInvoiceLegal: async function() {
      const price = this.fullInfo.dynamicDiscountPrice || this.order.fullPrice || this.order.price;

      let orderWithData = await showOrder(this.orderId);
      const mtsbuCode = orderWithData.data.data?.mtsbuCode ?? null;

      let invoiceLegalData = {
        company: this.order.companyInfo?.name,
        code: this.order.info?.erdpyCode ?? '',
        price: price,
        mtsbuCode: mtsbuCode,
      };
      let response = await getPaymentInvoice(this.orderId, price, 'legal-entity-insurance');
      showOrder(this.orderId).then(response => {
        this.order = response.data.data;
        this.orderId = this.order.order.id;
      });

      let params = new URLSearchParams(invoiceLegalData).toString();
      downloadInvoiceLegal(this.getParentUserId, this.orderId, params);
    },

    showAllOrderPaymentWays() {
      const price = this.fullInfo.dynamicDiscountPrice || this.order.fullPrice || this.order.price;
      const earnings = this.fullInfo.dynamicDiscountedSum > 0 ? this.fullInfo.dynamicEarnings : this.earnings;
      this.$refs.modalGetAllPaymentWays.open(this.orderId, price, earnings);
    },

    makeContract(type) {
      if (this.checkFinMonitoring()) {
        return;
      }

      this.submitCheck = true;
      if (this.agreement) {
        this.startOrderDateDisabled = true;
        this.showAnimateModal();
        const offerInfo = Object.assign({}, this.offerInfo, {
          dynamicDiscountPrice: this.fullInfo.dynamicDiscountPrice,
          discountDetails: this.fullInfo.discountPercent > 0 ? null : {
            dynamicDiscountPrice: this.fullInfo.dynamicDiscountPrice,
            dynamicDiscountPercent: this.fullInfo.dynamicDiscountPercent,
            dynamicDiscountedSum: this.fullInfo.dynamicDiscountedSum,
            dynamicEarnings: this.fullInfo.dynamicEarnings,
            earnings: this.fullInfo.earnings
          }
        });
        const searchInfo = {
          startDate: this.searchInfo.startDate,
          homeType: this.searchInfo.homeType.param,
          insuranceAmount: this.searchInfo.insuranceAmount.param,
          insurancePeriod: this.searchInfo.insurancePeriod.param,
          earnings: this.searchInfo.earning.value,
        };
        const userInfo = this.payer;
        const houseInfo = this.homeObjectInfo;

        let params = {
          type: type,
          statusId: null,
        };

        this.$store.commit('SET_HOME_INFO_USER', userInfo);
        this.$store.commit('SET_HOME_INFO_HOUSE', houseInfo);

        orderHome(offerInfo, searchInfo, userInfo, houseInfo, this.orderId, params, this.bonusSystemValue).then((response) => {
          $('#modalPayAnimation').modal('hide');
          if (response && response.data.count >= 1) {
            this.offerInfo.confirmContractStatus = true;
            this.offerInfo.invoiceLink = response.data.data[0]?.mtsbuLink;

            this.confirmContractStatus = true;
            this.orderId = response.data.data[0].id;
            this.$store.commit('SET_HOME_FULL_ORDER', response.data.data[0].id);

            if (response.data.data[0].status != 'declared') {
              this.$alert('Поліс не оформлен', '', 'error');
            }

            return true;
          } else if(response && response.data.message) {
            this.dataResponse = response.data.message;
            $('#modalResponseStatus').modal('show');
          }

          this.$alert('Поліс не заявлений, перевірте будь ласка дані і спробуйте ще!', '', 'error', { width: '300px' });
        }).catch(error => {
          $('#modalPayAnimation').modal('hide');
          if (error?.response?.data?.data?.orderId && error?.response?.data?.data?.orderId[0].includes('недостатньо коштів')) {
            this.$alert(error?.response?.data?.data?.orderId[0], 'Недостатньо коштів', 'error');
          } else if (error?.response?.data?.message) {
            if(error.response.data.message == 'Заблокований для ордеров'){
              this.$refs.showModalDisableCreateOrders.open();
            }else{
              this.$alert(error.response.data.message, '', 'error');
            }
          } else {
            this.$alert('Поліс не оформлено', '', 'error');
          }
        });
      }
    },

    confirmContract() {
      this.showAnimateModal();

      let data = {
        orderId: this.orderId,
        bonusSystemValue: this.bonusSystemValue
      };

      if (this.offerInfo.prolongOrderId) {
        data.prolongOrderId = this.offerInfo.prolongOrderId;
      }

      contractHome(data).then((response) => {
        $('#modalPayAnimation').modal('hide');
        if (response?.data?.status === 'success' && !!response.data.data[0].contractId) {
          $('#modalFlightSuccess').modal('show');
          this.$store.commit('SET_HOME_CONTRACT_ID', response.data.data[0].contractId);
          this.contractId = response.data.data[0].contractId;
          return true;
        }

        this.$alert('Поліс страхування житла не оформлено', '', 'error');
      }).catch(error => {
        if (error?.response?.data.data.length > 0 && error?.response?.data?.data?.orderId[0].includes('недостатньо коштів')) {
          this.$alert(error?.response?.data?.data?.orderId[0], '', 'error');
        }else if(error?.response?.data?.message){
          this.dataResponse = error?.response?.data?.message;
          $('#modalResponseConfirmStatus').modal('show');
        } else {
          this.$alert('Поліс страхування житла не оформлено', '', 'error');
        }

        $('#modalPayAnimation').modal('hide');
      });
    },

    async retryRequest(fn, attempts = 3) {
      for (let i = 0; i < attempts; i++) {
        try {
          return await fn();
        } catch (e) {
          if (i === attempts - 1) throw e;
          await new Promise(r => setTimeout(r, 500 * (i + 1)));
        }
      }
    },
    recalculateEarningsFallback() {
      if (!Number(this.earnings)) {
        this.earnings = this.offerInfo?.earnings || this.order?.earning?.value || 0;
      }
    },
    async recalculateEarnings() {
      this.dataIsLoadEarning = true;
      let startDate = moment(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()+1)).format('DD.MM.YYYY');

      let params = {
        startFrom: startDate,
        homeType: this.order.homeType.param,
        insuranceAmount: this.order.insuranceAmount.param,
        insurancePeriod: this.order.insurancePeriod.param,
        earnings: this.order.earning.value,
      };

      try {
        const { data: { data } }  = await this.retryRequest(() => axios.post('/api/' + process.env.VUE_APP_SERVER_MODE + '/insurance/home/calculator', params));
        const offer = this.$_.find(data, (item) => {
          return item.offerId === this.offerInfo.offerId;
        });
        if (offer) {
          this.order.fullPrice = offer.price;
          this.order.price = offer.price;
          this.earnings = offer.earnings;
        } else {
          this.recalculateEarningsFallback();
        }
      } catch (error) {
        console.error('recalculateEarnings failed', error);
        this.recalculateEarningsFallback();
      } finally {
        this.dataIsLoadEarning = false;
      }
    },

    showAnimateModal() {
      $('#modalPayAnimation').modal({
        backdrop: 'static',
        keyboard: true,
        show: true,
      });

      let i = 0;

      if (i == 0) {
        i = 1;
        let width = 1;
        let id = setInterval(frame, 200);

        /**
         *
         */
        function frame() {
          if (width >= 99) {
            clearInterval(id);
            i = 0;
          } else {
            width += 2;
            $('.results_anime_percent-text').text(`${width}%`);
            $('.results_anime_line-scale').css({ width: `${width}%` });
          }
        }
      }
    },

    downloadContract() {
      $('#modalFlightSuccess').modal('hide');
      downloadOrder(this.$store.getters.USER.id, this.order.id);
    },

    showDraft() {
      downloadOrder(this.$store.getters.USER.id, this.order.id);
    },

    confirmFinMonitoring() {
      setTimeout(() => {
        this.isAgreeFinMonitoring = true;
        this.makeContract('make');
      }, 1500);
    },

    checkFinMonitoring() {
      if (this.order.price >= 40000 && !this.isAgreeFinMonitoring) {
        this.showFinMonitoringModal = true;

        return true;
      }

      return false;
    },
  },
};
</script>
